import React, { useState, useEffect } from 'react';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';
import FooterCopyright from "../components/FooterCopyright";
import img17 from '../assets/image17.webp';
import img8 from '../assets/image8.webp';
import img1 from '../assets/image1.webp';
import '../styles/hero.css';

const Contact = () => {
  const images = [img17, img8, img1];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setCurrent((c) => (c + 1) % images.length), 4200);
    return () => clearInterval(id);
  }, [images.length]);

  return (
    <>
      <div className="page-hero contact-hero">
        {images.map((img, i) => (
          <div
            key={i}
            className={`bg-layer ${i === current ? 'active' : ''}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <button className="hero-nav prev" onClick={() => setCurrent((current - 1 + images.length) % images.length)} aria-label="Previous image">‹</button>
        <button className="hero-nav next" onClick={() => setCurrent((current + 1) % images.length)} aria-label="Next image">›</button>
        <div className="page-hero-inner">
          <h1 className="title">Contact Us</h1>
        </div>
        <div className="hero-dots">
          {images.map((_, i) => (
            <button
              key={i}
              className={`hero-dot ${i === current ? 'active' : ''}`}
              onClick={() => setCurrent(i)}
              aria-label={`Go to image ${i + 1}`}
            />
          ))}
        </div>
      </div>
      <div className="map">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d475.7130384334104!2d78.2964347!3d17.4738612!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93004d110f1b%3A0x3509d79d506a3bff!2sLittle%20Sanctum%20Montessori!5e0!3m2!1sen!2sin!4v1744376831219!5m2!1sen!2sin" 
          style={{ border: 0 }}
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"></iframe>
      </div>
      <ContactUs />
      <Footer />
      <FooterCopyright />
    </>
  )
}

export default Contact
